import React, { useState } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../mock';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center">
            <button 
              onClick={() => scrollToSection('hero')} 
              className="flex items-center hover:opacity-80 transition-opacity"
            >
              <img 
                src={companyInfo.logo} 
                alt="Greenwood Property Group" 
                className="h-14 w-auto"
              />
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <div className="relative group">
              <button 
                className="flex items-center space-x-1 text-gray-700 hover:text-amber-800 transition-colors font-medium"
                onMouseEnter={() => setServicesOpen(true)}
                onMouseLeave={() => setServicesOpen(false)}
              >
                <span>Services</span>
                <ChevronDown className="w-4 h-4" />
              </button>
              
              {servicesOpen && (
                <div 
                  className="absolute top-full left-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 py-2"
                  onMouseEnter={() => setServicesOpen(true)}
                  onMouseLeave={() => setServicesOpen(false)}
                >
                  <button 
                    onClick={() => scrollToSection('property-services')}
                    className="w-full text-left px-4 py-2 text-gray-700 hover:bg-amber-50 hover:text-amber-800 transition-colors"
                  >
                    Property Services
                  </button>
                  <button 
                    onClick={() => scrollToSection('real-estate')}
                    className="w-full text-left px-4 py-2 text-gray-700 hover:bg-amber-50 hover:text-amber-800 transition-colors"
                  >
                    Real Estate
                  </button>
                  <button 
                    onClick={() => scrollToSection('cabin-rentals')}
                    className="w-full text-left px-4 py-2 text-gray-700 hover:bg-amber-50 hover:text-amber-800 transition-colors"
                  >
                    Cabin Rentals
                  </button>
                </div>
              )}
            </div>
            
            <button 
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-amber-800 transition-colors font-medium"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-amber-800 transition-colors font-medium"
            >
              Contact
            </button>
            <Button 
              onClick={() => scrollToSection('contact')}
              className="bg-amber-800 hover:bg-amber-900 text-white transition-colors"
            >
              Get Started
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-gray-700"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('property-services')}
                className="text-left text-gray-700 hover:text-amber-800 transition-colors font-medium"
              >
                Property Services
              </button>
              <button 
                onClick={() => scrollToSection('real-estate')}
                className="text-left text-gray-700 hover:text-amber-800 transition-colors font-medium"
              >
                Real Estate
              </button>
              <button 
                onClick={() => scrollToSection('cabin-rentals')}
                className="text-left text-gray-700 hover:text-amber-800 transition-colors font-medium"
              >
                Cabin Rentals
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="text-left text-gray-700 hover:text-amber-800 transition-colors font-medium"
              >
                About
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-left text-gray-700 hover:text-amber-800 transition-colors font-medium"
              >
                Contact
              </button>
              <Button 
                onClick={() => scrollToSection('contact')}
                className="bg-amber-800 hover:bg-amber-900 text-white w-full transition-colors"
              >
                Get Started
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
